module.exports = __webpack_public_path__ + "static/media/poivrons.a11cfc8d.svg";